import React from 'react';
import { BaseLayout } from 'layouts';
import { Profile } from '../../features/dashboard/Profile';
import { Stats } from '../../features/dashboard/Stats';
import { Programs } from '../../features/dashboard/Programs';
import { RecentActivity } from '../../features/dashboard/RecentActivity';
import { BoostBanner } from '../../features/dashboard/BoostBanner ';
import { QuestsBanner } from '../../features/dashboard/QuestsBanner';
import { QuestsBlock } from '../../features/dashboard/Quests';

export const Dashboard = () => {
  return (
    <BaseLayout className="lg:!bg-[#0C0C0E]">
      <Profile />
      <QuestsBanner />
      <BoostBanner />
      <Programs />
      <QuestsBlock />
      <RecentActivity />
    </BaseLayout>
  );
};
